import React, { Fragment } from 'react';
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Input, Row } from 'reactstrap';
import { and, CustomStyles, CustomstyleText, CustomstyleText2, CustomstyleText3, CustomstyleText4, CustomstyleText5, form, invalid, novalidate, SubmitForm, TermsText, valid } from '../../../../Constant';
import { useForm } from 'react-hook-form';
import { Btn,  H5 } from '../../../../AbstractElements';
import { StateSelect } from '../../../../Data/Ecommerce/ProductPage';
import InputControl from '../../../Common/FormInputs/InputControl';

const CustomStylesClass = () => {
  const {
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const formSubmitHandler = () => {
    reset();
  };
  return (
    <Fragment>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{CustomStyles}</H5>
          <span>
            {CustomstyleText} <code className='text-danger'>{novalidate}</code> {CustomstyleText2} <code className='text-danger'>&lt;{form}&gt;</code>
            {CustomstyleText3}
          </span>
          <span>
            {CustomstyleText4} <code className='text-danger'>{invalid} </code> {and} <code className='text-danger'>{valid} </code> {CustomstyleText5}
          </span>
        </CardHeader>

        <CardBody>
          <Form className='needs-validation' noValidate='' onSubmit={handleSubmit(formSubmitHandler)}>
            <Row className='g-3'>
              <Col md='4'>
                <InputControl controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter First Name *' register={{ ...register('first_name', { required: 'is Required.' }) }} />
              </Col>
              <Col md='4'>
                <InputControl controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter Last Name *' register={{ ...register('last_name', { required: 'is Required.' }) }} />
              </Col>
              <Col md='4 mb-3'>
                <InputControl pereFix='@' controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter Last Name *' register={{ ...register('user_name', { required: 'is Required.' }) }} />
              </Col>
            </Row>
            <Row className='g-3'>
              <Col md='6'>
                <InputControl controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter City Name *' register={{ ...register('city', { required: 'is Required.' }) }} />
              </Col>
              <Col md='3'>
                <InputControl control={control} placeholder='select...' controlInput='select' options={StateSelect} className='form-select' errors={errors} register={{ ...register('state', { required: 'is Required.' }) }} />
              </Col>
              <Col md='3' className='mb-3'>
                <InputControl controlInput='input' className='form-control' type='number' errors={errors} placeholder='Enter Zip Code *' register={{ ...register('zip', { required: 'is Required.', minLength: '6', maxLength: '6' }) }} />
              </Col>
            </Row>
            <FormGroup>
              <div className='form-check'>
                <div className='checkbox p-0'>
                  <Input className='form-check-input' id='invalidCheck' type='checkbox' />
                  <Label className='form-check-label' htmlFor='invalidCheck'>
                    {TermsText}
                  </Label>
                </div>
              </div>
            </FormGroup>
            <Btn color='primary'>{SubmitForm}</Btn>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default CustomStylesClass;
